// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ii-0";
export var fileCarousel = "_ii-2";
export var removeFileButton = "_ii-1";